import React, { useEffect } from 'react';
import Navbar from '../global/Navbar';
import Footer from '../global/Footer';
import PageMeta from '../shared/PageMeta';
import {
  UPDATE_INDEX_CARDS,
  UPDATES_AS_OF,
  DELIVERY_CONTEXT,
  UPDATES_INDEX_LEDE,
} from '../../../content/snowflakeUpdates';
import { sortUpdateIndexCards } from '../../../content/sortUpdateIndexCards';
import { applyPublicShellHead } from '../../../content/seoMeta';

export default function UpdatesIndex() {
  useEffect(() => applyPublicShellHead('/updates'), []);
  const cards = sortUpdateIndexCards(UPDATE_INDEX_CARDS);
  const heroAsOf = (cards[0] && cards[0].asOf) || UPDATES_AS_OF;

  return (
    <div>
      <PageMeta path="/updates" />
      <Navbar />
      <main className="bg-white">
        <div className="updates-mobile-pad container-x py-14 sm:py-20">
          <span className="updates-chip inline-flex rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide">
            Snowflake updates
          </span>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-semibold tracking-tight text-brand-900 sm:text-5xl">
            What changed in Snowflake
          </h1>
          <p className="mt-4 text-sm font-medium text-ink-500">As of {heroAsOf}</p>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-600">
            {UPDATES_INDEX_LEDE} {DELIVERY_CONTEXT}
          </p>
          <ul className="mt-10 grid grid-cols-1 gap-4">
            {cards.map((post) => (
              <li key={post.path}>
                <a
                  href={post.path}
                  className="block overflow-hidden rounded-2xl border border-brand-200 bg-white transition-colors hover:border-brand-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-700 motion-reduce:transition-none"
                >
                  <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1 border-b border-brand-100 bg-brand-50 px-5 py-3 sm:px-6">
                    <span className="updates-chip inline-flex rounded-full px-2.5 py-0.5 text-xs font-bold">
                      {post.tag}
                    </span>
                    <span className="inline-flex items-center gap-2">
                      <span className="text-xs font-semibold uppercase tracking-wide text-brand-700">
                        Note
                      </span>
                      <span className="text-xs font-medium text-ink-600">{post.asOf || UPDATES_AS_OF}</span>
                    </span>
                  </div>
                  <div className="p-5 sm:p-6">
                    <h2 className="font-display text-xl font-semibold tracking-tight text-brand-900 sm:text-2xl">
                      {post.title}
                    </h2>
                    <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink-600 sm:text-base">
                      {post.summary}
                    </p>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
}
